module.exports = __webpack_public_path__ + "images/favs_black.png";